import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { getClientById } from '../../../../clients';
import {
  Wrapper,
  Text,
  Alternatives,
  AlternativesTitle,
  Chips,
  Chip
} from './styled';

const UnsupportedBlock = ({ textId, alternatives, onSelectClient }) => {
  const intl = useIntl();

  return (
    <Wrapper>
      <Text>{intl.formatMessage({ id: textId })}</Text>
      <Alternatives>
        <AlternativesTitle>
          {intl.formatMessage({ id: 'mcp.unsupported.alternatives' })}
        </AlternativesTitle>
        <Chips>
          {alternatives.map((clientId) => (
            <Chip
              key={ clientId }
              onClick={ () => onSelectClient(clientId) }
              type="button"
            >
              {getClientById(clientId).label}
            </Chip>
          ))}
        </Chips>
      </Alternatives>
    </Wrapper>
  );
};

UnsupportedBlock.propTypes = {
  textId: PropTypes.string.isRequired,
  alternatives: PropTypes.arrayOf(PropTypes.string),
  onSelectClient: PropTypes.func.isRequired
};

UnsupportedBlock.defaultProps = {
  alternatives: []
};

export default UnsupportedBlock;
